<div class="row pb-2 m-0">
    <div class="col"></div>
    <div class="col-auto">
        <button *ngIf="this.common.PageRight.IsAdd" type="button" class="btn btn-primary"
            [routerLink]="['/attendancedevice/sitebranchmapping/add/0']" [disabled]="isDisabled">
            <i class="bi bi-plus-lg" *ngIf="!isDisabled"></i>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
            {{!isDisabled?'Add Mapping':'Loading...'}}
        </button>

        <button *ngIf="this.common.PageRight.IsPrint" type="button" class="btn btn-primary mx-2" (click)="ExcelDump()"
            [disabled]="isDisabled">
            <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" *ngIf="isDisabled"></span>
            {{!isDisabled?'Export':'Loading...'}}
        </button>
    </div>
</div>
<div class="card">
    <div class="card-header">
        <div class="card-title">Device Branch/Site</div>
    </div>
    <div class="card-body">
        <table datatable [dtOptions]="this.dtoptions" width="100%" [dtTrigger]="dtTrigger"
            class="customeDatatable table table-bordered">
            <thead class="table-light">
                <tr>
                    <th style="width: 5px;">#</th>
                    <th style="width: 5px;">View</th>
                    <th style="width: 150px;">Status / Date</th>
                    <th style="width: 85px;">LastSync</th>
                    <th style="width: 85px;">Device Serial No</th>
                    <th style="width: 50px;">Model</th>
                    <th style="width: 150px;">Branch</th>
                    <th style="width: 200px;">Site</th>
                    <th>Action</th>
                    <!-- <th style="width:115px">Device</th> -->
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let element of Data; let i = index">
                    <th scope="row" style="width: 5px;">{{ i + 1 }}</th>
                    <td style="width: 80px;">
                        <button type="button" class="btn btn-outline-primary btn-sm"
                            style="font-size: 0.75rem; padding: 0.25rem 0.5rem;"
                            [routerLink]="['/attendancedevice/sitebranchmapping/detail/'+element['ESS_SiteWiseDeviceDetailsID']]">
                            <i class="bi bi-info-square me-1"></i> View
                        </button>
                    </td>
                    <td style="width: 150px"> <span class="badge"
                            [ngClass]="{'warning':element['IsOffline'],'success':!element['IsOffline']}">
                            {{element['IsOffline']?'Offline':'Online'}}</span>
                        <br />{{element['DeviceModifiedOn']}}
                    </td>
                    <td style="width: 85px;"> {{element['LastSyncedOn']}}</td>
                    <td style="width: 85px;"> {{element['SerialNumber']}}</td>
                    <td style="width: 50px;"> {{element['Module']}}</td>
                    <td style="width: 150px;">{{element['BranchCode']}} - {{element['BranchName']}}</td>
                    <td style="width: 200px;">{{element['SiteCode']}} - {{element['SiteName']}}</td>
                    <td class="text-center">
                        <button type="button" (click)="Delete(i)" class="btn btn-sm" name="delete"
                            style="color: rgb(236, 4, 4);"><i class="bi bi-trash-fill"></i></button>
                    </td>
                    <!-- <td class="text-center" style="width:115px">
                        <i class="badge success bi-people-fill ms-1"
                            [routerLink]="['/attendancedevice/device/deviceattendance/'+element['SerialNumber']]"></i>

                        <i class="badge success bi-person-lines-fill ms-1"
                            [routerLink]="['/attendancedevice/device/deviceemployee/'+element['SerialNumber']]"></i>

                        <i class="badge warning bi-gear-wide-connected ms-1"
                            [routerLink]="['/attendancedevice/device/deviceconfiguration/'+element['SerialNumber']]"></i>
                    </td> -->
                </tr>
            </tbody>
        </table>

    </div>
</div>